export const RATINGS_SLIDING = 'ratings_sliding';
export const SQUARES = 'accessible_squares';
